import { render, staticRenderFns } from "./payStatus.vue?vue&type=template&id=19c5b7ad&scoped=true"
import script from "./payStatus.vue?vue&type=script&lang=js"
export * from "./payStatus.vue?vue&type=script&lang=js"
import style0 from "./payStatus.vue?vue&type=style&index=0&id=19c5b7ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c5b7ad",
  null
  
)

export default component.exports